import { useEffect, useRef } from "react";
import { NiceBadge } from "@/ui/CommunicationView/ChatConversation/PromptMessageContainer/PromptMessageContainer";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import { EditorObjectState } from "@/Apps/Pages/V2Editor/components/EditorObject/EditorObject";
import { Layout } from "@phosphor-icons/react";
import { ArtifactOptions } from "@/Apps/AITools/types";
import { cleanThisContent, hasDuplicates } from "@/Apps/Pages/V2Editor/actions";
import { addBodyIfNone } from "../../PageBuilderArtifact";

interface SectionBuilderFromStructuredMessageProps {
  payload?: any;
  name?: string;
  artifactOptions?: ArtifactOptions;
  setArtifactOptions?: (options: ArtifactOptions) => void;
}

export const SectionBuilderFromStructuredMessage = (props: SectionBuilderFromStructuredMessageProps) => {

  const { payload, name, artifactOptions, setArtifactOptions } = props;
  
  // Use ref to track if we've already processed this section
  const processedSectionRef = useRef<string | null>(null);

  console.log("SectionBuilderFromStructuredMessage", "payload", payload);

  const sectionId = payload?.sectionContent?.find(
    (item: any) => item.type === ComponentTypes.SECTION
  )?.id;

  
  const sectionType = payload?.sectionContent?.find(
    (item: any) => item.type === ComponentTypes.SECTION
  )?.label;
  
  // Create a stable reference for sectionContent by stringifying it
  const sectionContentString = JSON.stringify(payload?.sectionContent || []);
  
  // return <div>{JSON.stringify(payload)}</div>;
  useEffect(() => {
    // Only process if we have sectionContent and haven't processed this section before
    if (payload?.sectionContent && sectionId && processedSectionRef.current !== sectionId) {
      const sectionContent = payload.sectionContent;
        // locate all text objects in the section content
        const textObjects = sectionContent.filter(
          (settings: any) =>
            settings?.type === ComponentTypes.TEXT ||
            settings?.type === ComponentTypes.PARAGRAPH ||
            settings?.type === ComponentTypes.HEADLINE ||
            settings?.type === ComponentTypes.V1BUTTON ||
            settings?.type === ComponentTypes.LISTITEM ||
            settings?.type === ComponentTypes.BUTTON
        );
      // set all text objects to hidden initially
        const newSectionContent = sectionContent.map((item: any) => {
          if (textObjects.some((textObj: any) => textObj.id === item.id)) {
            return {
              ...item,
              leaveState: EditorObjectState.HIDDEN,
              state: EditorObjectState.HIDDEN,
            };
          }
          return item;
        });

          const newPageContent = [
            ...(artifactOptions?.container?.pageContent || []),
            ...newSectionContent,
          ];

          if (!hasDuplicates(newPageContent)) {

            const newArtifactOptions = {
              ...artifactOptions,
              isShowing: true,
              container: {
                ...(artifactOptions?.container || {}),
                type: "page_builder",
                title: "Page Builder (Section Builder)",
                // append it to the existing content
                pageContent: addBodyIfNone(
                  cleanThisContent(newPageContent)
                ),
              },
            };
            console.log("sectionBuilder", "newArtifactOptions", newArtifactOptions);

            setArtifactOptions?.(newArtifactOptions as ArtifactOptions);

            // scroll to the section
            setTimeout(() => {
              document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "end" });
            }, 1000);

          } else {
            console.log("not rendering", "newPageContent has duplicates", newPageContent);
          }
        // Mark this section as processed
        processedSectionRef.current = sectionId;
        console.log("sectionContent has", sectionContent.length, "items", "will add to page via artifactOptions");      
    }
  }, [sectionContentString]);

  return (
    <div>
      <NiceBadge
        // caption={name}
        caption={`Building: ${sectionType.slice(0, 1).toUpperCase() + sectionType.slice(1).toLowerCase()} Section Elements`}
        onClick={() => {
          if (sectionId) {
            document
              .getElementById(sectionId)
              ?.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }}
        icon={<Layout />}
      />
      {/* <ReactJson src={sectionContent} name={payload?.artifactId} collapsed /> */}
    </div>
  );
};
